import { multiDealsRequestConstructor } from '@monorepo/deals';
import { MultiDealService } from '@spilca/order_ts/v1/order_web/multi_deal_web_pb_service';

const getMultiDeals = (filter: object | null) =>
  multiDealsRequestConstructor(filter, MultiDealService.ListMultiDeal);

export default getMultiDeals;
